module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-mobile-es.62f452b2.png";